var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 6,
    fill: "#CB998D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 21H21V23H13V21ZM13 17H21V19H13V17ZM19 7H11C9.9 7 9 7.9 9 9V25C9 26.1 9.89 27 10.99 27H23C24.1 27 25 26.1 25 25V13L19 7ZM23 25H11V9H18V14H23V25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/Export.3e52274b8ef6c31816c5508dc80d70b7.svg";
export { ForwardRef as ReactComponent };